import React, { useEffect, useRef, useState } from "react";
import { Pencil } from "lucide-react";
import PopUp from "../containers/PopUp";
import AddressShipping from "../../components/addressShipping/AddressShipping";
import {
  resendVerificationEmail,
  sendVerifiedMail,
  LogOut,
  setUserEntry,
  dismissEmailVerification,
  updateVerificationEmail,
} from "../../server/Customer";
import { useDispatch } from "react-redux";
import * as actionType from "../../store/action";

const UserResetEmail = ({ emailPassword, Email, Password, customerId }) => {
  const [verificationCode, setVerificationCode] = useState("");
  const [email, setEmail] = useState(Email || "");
  const [editingEmail, setEditingEmail] = useState(false);
  const [addAddress, setAddAddress] = useState(false);
  const emailInputRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setEmail(Email || "");
    setEditingEmail(false);
  }, [Email]);

  useEffect(() => {
    if (editingEmail) {
      emailInputRef.current?.focus();
      emailInputRef.current?.select();
    }
  }, [editingEmail]);

  const handleSubmit = (e) => {
    e.preventDefault();
    check();
  };

  const check = () => {
    dispatch(sendVerifiedMail(verificationCode))
      .then(() => {
        setAddAddress(true);
      })
      .catch((err) => {
        console.error("Verification error:", err);
      });
  };

  const resendEmail = () => {
    const normalized = email.trim().toLowerCase();
    const original = String(Email || "")
      .trim()
      .toLowerCase();

    // Empty field must not silently resend to the original while UI shows "—".
    if (!normalized) {
      setEmail(Email || "");
      setEditingEmail(false);
      return;
    }

    const action =
      normalized !== original
        ? updateVerificationEmail(normalized)
        : resendVerificationEmail();

    dispatch(action)
      .then(() => {
        setEmail(normalized);
        setEditingEmail(false);
      })
      .catch((err) => {
        console.error("Resend verification error:", err);
      });
  };

  const switchAccount = () => {
    dispatch(LogOut());
    dispatch(setUserEntry([true, "login"]));
  };

  return (
    <PopUp
      width="700px"
      close={() => dispatch(dismissEmailVerification())}
      wrapperClassName="popup-wrapper--flush popup-wrapper--colored-header"
    >
      {addAddress ? (
        <AddressShipping
          parent="reset"
          setSelectedAddres={() =>
            dispatch({ type: actionType.VERIFIED_EMAIL })
          }
        />
      ) : (
        <div className="register-mail">
          <div className="register-head">
            <h3> ההרשמה כמעט הושלמה, עכשיו רק נשאר לאמת את המייל</h3>
          </div>
          <div className="register-body">
            <p>
              שלחנו קוד אימות לכתובת המייל. ניתן לערוך אותה אם יש טעות, ואז
              לשלוח קוד חדש.
            </p>
            <div className="register-mail__email-row">
              {editingEmail ? (
                <input
                  ref={emailInputRef}
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      setEditingEmail(false);
                    }
                    if (e.key === "Escape") {
                      setEmail(Email || "");
                      setEditingEmail(false);
                    }
                  }}
                  onBlur={() => setEditingEmail(false)}
                  aria-label="כתובת מייל"
                  autoComplete="email"
                  dir="ltr"
                  className="register-mail__email-input"
                />
              ) : (
                <>
                  <span className="register-mail__email-value" dir="ltr">
                    {email || "—"}
                  </span>
                  <button
                    type="button"
                    className="register-mail__email-edit"
                    onClick={() => setEditingEmail(true)}
                    aria-label="עריכת כתובת מייל"
                    title="עריכת כתובת מייל"
                  >
                    <Pencil size={15} strokeWidth={2} aria-hidden />
                  </button>
                </>
              )}
            </div>
            <p>יש להכניס את הסיסמה שקיבלתם למייל</p>
            <form onSubmit={handleSubmit}>
              <div>
                <input
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  aria-label="קוד אימות"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                />
              </div>
              <div>
                <button className="btn" type="submit">
                  לאישור
                </button>
                <button
                  className="forgot-pass resend-email-btn"
                  type="button"
                  onClick={resendEmail}
                >
                  שליחת קוד חדש
                </button>
              </div>
            </form>
            <button
              type="button"
              className="register-mail__alt-btn"
              onClick={switchAccount}
            >
              התחברות לחשבון אחר
            </button>
          </div>
        </div>
      )}
    </PopUp>
  );
};

export default UserResetEmail;
